module.exports = __webpack_public_path__ + "img/c_3.1893e98a.jpg";